var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScalable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 241,
    height: 197,
    viewBox: "0 0 241 197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10221",
    "data-name": "Group 10221",
    transform: "translate(-954.001 -581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_350",
    "data-name": "Subtraction 350",
    transform: "translate(-11237 -9761)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12422,10539h-221a10.012,10.012,0,0,1-10-10v-147a10.011,10.011,0,0,1,10-10h71a40,40,0,1,0,80,0h70a10.011,10.011,0,0,1,10,10v147A10.012,10.012,0,0,1,12422,10539Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12422.0009765625 10538 C 12426.9638671875 10538 12431.0009765625 10533.962890625 12431.0009765625 10529 L 12431.0009765625 10382 C 12431.0009765625 10377.0380859375 12426.9638671875 10373.0009765625 12422.0009765625 10373.0009765625 L 12352.9892578125 10373.0009765625 C 12352.8662109375 10378.181640625 12351.7880859375 10383.2099609375 12349.7783203125 10387.958984375 C 12347.7158203125 10392.837890625 12344.759765625 10397.22265625 12340.9931640625 10400.990234375 C 12337.23046875 10404.7548828125 12332.845703125 10407.7109375 12327.9619140625 10409.7763671875 C 12322.90625 10411.9150390625 12317.537109375 10412.9990234375 12312.001953125 10412.9990234375 C 12306.4677734375 10412.9990234375 12301.09765625 10411.9150390625 12296.0419921875 10409.7763671875 C 12291.158203125 10407.7109375 12286.7734375 10404.7548828125 12283.0107421875 10400.990234375 C 12279.244140625 10397.22265625 12276.2880859375 10392.837890625 12274.2255859375 10387.958984375 C 12272.2158203125 10383.208984375 12271.1376953125 10378.181640625 12271.0146484375 10373.0009765625 L 12201.0009765625 10373.0009765625 C 12196.0380859375 10373.0009765625 12192.0009765625 10377.0380859375 12192.0009765625 10382 L 12192.0009765625 10529 C 12192.0009765625 10533.962890625 12196.0380859375 10538 12201.0009765625 10538 L 12422.0009765625 10538 M 12422.0009765625 10539 L 12201.0009765625 10539 C 12195.4873046875 10539 12191.0009765625 10534.513671875 12191.0009765625 10529 L 12191.0009765625 10382 C 12191.0009765625 10376.486328125 12195.4873046875 10372.0009765625 12201.0009765625 10372.0009765625 L 12272.0029296875 10372.0009765625 C 12272.0029296875 10377.400390625 12273.060546875 10382.6376953125 12275.146484375 10387.5693359375 C 12277.1591796875 10392.330078125 12280.04296875 10396.607421875 12283.7177734375 10400.283203125 C 12287.390625 10403.95703125 12291.6689453125 10406.8408203125 12296.431640625 10408.85546875 C 12301.36328125 10410.94140625 12306.6015625 10411.9990234375 12312.001953125 10411.9990234375 C 12317.40234375 10411.9990234375 12322.640625 10410.94140625 12327.572265625 10408.85546875 C 12332.3349609375 10406.8408203125 12336.61328125 10403.95703125 12340.2861328125 10400.283203125 C 12343.9609375 10396.607421875 12346.8447265625 10392.330078125 12348.857421875 10387.5693359375 C 12350.943359375 10382.638671875 12352.0009765625 10377.400390625 12352.0009765625 10372.0009765625 L 12422.0009765625 10372.0009765625 C 12427.5146484375 10372.0009765625 12432.0009765625 10376.486328125 12432.0009765625 10382 L 12432.0009765625 10529 C 12432.0009765625 10534.513671875 12427.5146484375 10539 12422.0009765625 10539 Z",
    stroke: "none",
    fill: "#31e5e5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9554",
    "data-name": "Group 9554",
    transform: "translate(802.002 -1298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    transform: "translate(243 1879)",
    fill: "#031f4f",
    stroke: "#31e5e5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10054",
    "data-name": "Group 10054",
    transform: "translate(-994.566 1286.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6922",
    "data-name": "Path 6922",
    d: "M24.047,46.965H19.332A1.261,1.261,0,0,1,18.083,45.7V35.94a1.261,1.261,0,0,1,1.249-1.264h4.714a1.261,1.261,0,0,1,1.245,1.264V45.7a1.253,1.253,0,0,1-1.24,1.264h0",
    transform: "translate(1235 592.632)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6923",
    "data-name": "Path 6923",
    d: "M32.673,47.729H28.409a1.492,1.492,0,0,1-1.477-1.494V32.152a1.492,1.492,0,0,1,1.477-1.494h4.265a1.492,1.492,0,0,1,1.474,1.494V46.235a1.487,1.487,0,0,1-1.477,1.494Z",
    transform: "translate(1236.562 591.867)",
    fill: "#378c59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6924",
    "data-name": "Path 6924",
    d: "M41.334,48.48H37.452A1.678,1.678,0,0,1,35.788,46.8V28.4a1.678,1.678,0,0,1,1.664-1.683h3.882A1.678,1.678,0,0,1,43,28.4V46.8a1.673,1.673,0,0,1-1.664,1.683Z",
    transform: "translate(1238.125 591.116)",
    fill: "#378c59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6925",
    "data-name": "Path 6925",
    d: "M45.044,20.1l-9.512,9.511L29.792,24.5,21.528,33.4l-2.941-3.175,10.866-11.1,5.941,5.292,6.968-6.976Z",
    transform: "translate(1235.089 589.351)",
    fill: "#4bae71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6926",
    "data-name": "Path 6926",
    d: "M43.8,15.6l-7.3,2.084,5.433,5.352Z",
    transform: "translate(1238.251 589)",
    fill: "#4bae71"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalable);
export default __webpack_public_path__ + "static/media/Scalable.c35065ab489b3463abd57b04381c8e19.svg";
export { ForwardRef as ReactComponent };